export function convertImageToBinaryString(file): Promise<string> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.readAsBinaryString(file);

    fileReader.onloadend = function () {
      resolve(fileReader.result);
    };

    fileReader.onerror = function () {
      reject(fileReader.result);
    };
  });
}

export function convertImageToBase64(file): Promise<string> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.readAsDataURL(file);

    fileReader.onloadend = function () {
      resolve(fileReader.result);
    };

    fileReader.onerror = function () {
      reject(fileReader.result);
    };
  });
}
